export function isStickySupported() {
  const testNode = document.createElement('div');
  if (
    ['', '-webkit-', '-moz-', '-ms-'].some(prefix => {
      try {
        testNode.style.position = prefix + 'sticky';
      } catch (e) {
        // не обрабатываем
      }

      return testNode.style.position !== '';
    })
  ) {
    return true;
  }

  return false;
}
